import { useLocation, useNavigate } from "react-router-dom";
import { PRIVATE_ROUTES } from "./AddRoutesJson";
import { Button, Result } from "antd";
import RedirectLoginForUnAuth from "./RedirectLoginForUnAuth";

function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const getAllRoutePath = PRIVATE_ROUTES.map((Item) => Item.path);
  return (
    <div>
      {getAllRoutePath.includes(location.pathname) ? (
        <RedirectLoginForUnAuth />
      ) : (
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Button type="primary" onClick={() => navigate(-1)}>
              Back Home
            </Button>
          }
        />
      )}
      {/* {JSON.stringify(getAllRoutePath)} */}
    </div>
  );
}

export default NotFound;
